export interface JWTPayload {
  userId: string;
  exp: number;
  iat: number;
}

/**
 * Decode JWT payload
 * @param token JWT token string
 * @returns Decoded payload or null if invalid
 */
export function decodeJWTPayload(token: string): JWTPayload | null {
  try {
    const [header, payload, signature] = token.split('.');

    if (!header || !payload || !signature) {
      return null; // Invalid token format
    }
    // Decode the payload (base64)
    return JSON.parse(atob(payload)) as JWTPayload;
  } catch {
    // If we can't parse the token, return null
    return null;
  }
}
